import { useMemo } from 'react';
import { toast } from 'sonner';
import { useAiGlobalSettings } from '@/features/ai-credits/api/use-ai-admin';
import { AiSettingsForm } from '@/features/ai-credits/ui/ai-settings-form';
import type { EffectiveAiSettings } from '@/features/ai-credits/model/types';
import { useUpdatePassbook, type PassbookPermissionRow } from '../api/use-permissions';
import { StoresPanel } from './stores-panel';

/** IA do passbook: o padrão no topo, as exceções por loja embaixo, no mesmo desenho. */
export function PassbookAiPanel({ passbook }: { passbook: PassbookPermissionRow }) {
  const update = useUpdatePassbook(passbook.id);
  const { data: global } = useAiGlobalSettings();

  const inherited = useMemo<EffectiveAiSettings | undefined>(
    () =>
      global && {
        values: global,
        sources: { model: 'global', monthlyLimitUsd: 'global', renewMonthly: 'global' },
      },
    [global],
  );

  return (
    <div className="grid items-start gap-4 xl:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
      <section className="overflow-hidden rounded-2xl border border-border/60 bg-card">
        <h3 className="border-b border-border/60 px-4 py-3 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          Padrão do passbook
        </h3>
        <div className="p-4">
          <AiSettingsForm
            level="passbook"
            value={passbook.aiSettings}
            inherited={inherited}
            saving={update.isPending}
            onSave={(aiSettings) =>
              update.mutateAsync(
                { aiSettings },
                {
                  onSuccess: () => toast.success('IA do passbook salva.'),
                  onError: () => toast.error('Não deu para salvar.'),
                },
              )
            }
          />
        </div>
      </section>
      <StoresPanel passbook={passbook} />
    </div>
  );
}
